if (!customElements.get('home-curated')) {
  class HomeCurated extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.slider = this.querySelector('[data-js-home-curated-slider]');
      this.controls = this.querySelector('[data-js-home-curated-controls]');
      this.previousButton = this.querySelector('[data-js-home-curated-previous]');
      this.nextButton = this.querySelector('[data-js-home-curated-next]');
      this.counter = this.querySelector('[data-js-home-curated-counter]');
      this.currentCounter = this.querySelector('[data-js-home-curated-current]');
      this.totalCounter = this.querySelector('[data-js-home-curated-total]');

      if (!this.slider || !this.controls) return;

      this.updateControls = this.updateControls.bind(this);
      this.selectPrevious = this.selectPrevious.bind(this);
      this.selectNext = this.selectNext.bind(this);
      this.previousButton?.addEventListener('click', this.selectPrevious, {
        signal: this.abortController.signal,
      });
      this.nextButton?.addEventListener('click', this.selectNext, {
        signal: this.abortController.signal,
      });

      this.carouselObserver = new MutationObserver(() => this.connectCarousel());
      this.carouselObserver.observe(this.slider, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
      });
      this.connectCarousel();
    }

    disconnectedCallback() {
      this.disconnectCarousel();
      this.carouselObserver?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
    }

    connectCarousel() {
      const carousel = this.slider?.flickityt4s?.flkty;
      if (!carousel || carousel === this.carousel) return;

      this.disconnectCarousel();
      this.carousel = carousel;
      this.carousel.on('select', this.updateControls);
      this.carousel.on('resize', this.updateControls);
      this.carouselObserver?.disconnect();
      this.updateControls();
    }

    disconnectCarousel() {
      if (!this.carousel || !this.updateControls) return;

      this.carousel.off('select', this.updateControls);
      this.carousel.off('resize', this.updateControls);
      this.carousel = null;
    }

    getNavigationState() {
      const cellCount =
        this.carousel?.cells?.length || this.querySelectorAll('[data-select-flickity]').length || 1;
      const cellOuterWidth = this.carousel?.cells?.[0]?.size?.outerWidth || 1;
      const cellWidth = this.carousel?.cells?.[0]?.size?.width || cellOuterWidth;
      const cellGap = Math.max(0, cellOuterWidth - cellWidth);
      const sliderWidth = this.slider?.clientWidth || cellOuterWidth;
      const visibleCount = Math.max(
        1,
        Math.min(cellCount, Math.floor((sliderWidth + cellGap) / cellOuterWidth + 0.01)),
      );
      const total = Math.max(1, cellCount - visibleCount + 1);
      const selectedIndex = Math.min(this.carousel?.selectedIndex || 0, total - 1);

      return { selectedIndex, total };
    }

    selectPrevious() {
      const { selectedIndex } = this.getNavigationState();
      this.carousel?.select(Math.max(0, selectedIndex - 1));
    }

    selectNext() {
      const { selectedIndex, total } = this.getNavigationState();
      this.carousel?.select(Math.min(total - 1, selectedIndex + 1));
    }

    updateControls() {
      const { selectedIndex, total } = this.getNavigationState();
      const current = selectedIndex + 1;
      const hasOverflow = total > 1;

      if ((this.carousel?.selectedIndex || 0) > selectedIndex) {
        this.carousel.select(selectedIndex, false, true);
        return;
      }

      this.controls.hidden = !hasOverflow;
      this.classList.toggle('c-home-curated--has-overflow', hasOverflow);
      this.previousButton.disabled = !hasOverflow || current === 1;
      this.nextButton.disabled = !hasOverflow || current === total;
      this.currentCounter.textContent = String(current).padStart(2, '0');
      this.totalCounter.textContent = String(total).padStart(2, '0');

      if (this.counter) {
        const ofLabel = this.counter.dataset.ofLabel || 'of';
        this.counter.setAttribute('aria-label', `${current} ${ofLabel} ${total}`);
      }
    }
  }

  customElements.define('home-curated', HomeCurated);
}
